import type { App } from "./app";
import type { JSX } from "react";


export abstract class SignUpStep {
	abstract readonly title: string;
	abstract readonly view: () => JSX.Element;

	readonly previousStep: SignUpStep | null;
	protected readonly app: App;

	constructor(app: App, previousStep: SignUpStep | null = null) {
		this.app = app;
		this.previousStep = previousStep;
	}

	protected handleSubmit(): Promise<void> {
		return Promise.resolve();
	}
}
